<template>
  <div>
    <div class="title">门头照</div>
    <div class="img-wrap">
      <div class="img-content" v-for="(item, index) in doorPhotoList" :key="index">
        <el-image
          style="width: 100px; height: 100px; margin-right: 20px"
          :src="item"
          :preview-src-list="doorPhotoList"
        >
        </el-image>
        <span class="upload-time">{{ timeMap[item] || '--' }}</span>
      </div>
    </div>
    <div class="title">陈列照</div>
    <div class="img-wrap">
      <div class="img-content" v-for="(item, index) in displayPhotoList" :key="index">
        <el-image
          style="width: 100px; height: 100px; margin-right: 20px"
          :src="item"
          :preview-src-list="displayPhotoList"
        >
        </el-image>
        <span class="upload-time">{{ timeMap[item] || '--' }}</span>
      </div>
    </div>
    <div v-for="(item, index) in pickupsPhotoList" :key="index">
      <div class="title">第{{index+1}}次补拍照</div>
      <div class="img-wrap">
        <div class="img-content" v-for="(iItem, iIndex) in item.photos" :key="iIndex">
          <el-image
            style="width: 100px; height: 100px; margin-right: 20px"
            :src="iItem"
            :preview-src-list="item.photos"
          >
          </el-image>
          <span class="upload-time">{{ timeMap[iItem] || '--' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  watch: {
    value() {
      const row = this.value || {};
      // metadataVos 无图片类型，用 fileUrl 匹配展示数组里的图片，取 lastModified 作为上传时间
      const timeMap = {};
      (row.metadataVos || []).forEach((m) => {
        timeMap[m.fileUrl] = m.lastModified;
      });
      this.timeMap = timeMap;
      // 门头照：photo 可能是逗号拼接的多张图片
      const door = [];
      (row.doorPhotoRespVos || []).forEach((item) => {
        (item.photo || '').split(',').filter((url) => url).forEach((url) => door.push(url));
      });
      this.doorPhotoList = door;
      // 陈列照：photo 可能是逗号拼接的多张图片
      const display = [];
      (row.displayPhotoRespVos || []).forEach((item) => {
        (item.photo || '').split(',').filter((url) => url).forEach((url) => display.push(url));
      });
      this.displayPhotoList = display;
      // 补拍照：photos 为数组
      const pickups = [];
      (row.pickupsPhotoRespVos || []).forEach((item) => {
        pickups.push({ photos: item.photos || [] });
      });
      this.pickupsPhotoList = pickups;
    },
  },
  data() {
    return {
      doorPhotoList: [],
      displayPhotoList: [],
      pickupsPhotoList: [],
      timeMap: {},
    };
  },
};
</script>
<style scoped>
.title {
  font-size: 16px;
  padding: 10px 0;
}
.img-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.img-content{
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.upload-time{
  font-size: 12px;
  color: #909399;
}
</style>
